/* Product-page navigation and shipping labels only. Never changes a cart or offer. */
if (!customElements.get('product-choices')) {
  customElements.define('product-choices', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.updateShipping();
      const help = this.querySelector('[data-choice-help]');
      const comparison = this.querySelector('[data-choice-comparison]');
      if (help && comparison) {
        help.addEventListener('click', () => {
          comparison.open = true;
          help.setAttribute('aria-expanded', 'true');
          comparison.scrollIntoView({
            block: 'start',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        });
        comparison.addEventListener('toggle', () => {
          help.setAttribute('aria-expanded', String(comparison.open));
        });
      }

      // The shared hash is added only by product-choice links, not normal visits.
      const target = window.location.hash.slice(1);
      if (target !== this.id && target !== comparison?.id) return;
      if (target === comparison?.id) {
        comparison.open = true;
        help?.setAttribute('aria-expanded', 'true');
      }
      // Let Back/Forward restore the reader's previous scroll position normally.
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation?.type === 'back_forward') return;
      let readerInteracted = false;
      const markInteraction = () => { readerInteracted = true; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((event) => {
        window.addEventListener(event, markInteraction, { once: true, passive: true });
      });
      const alignTarget = () => {
        if (readerInteracted || !this.isConnected || window.location.hash.slice(1) !== target) return;
        document.getElementById(target)?.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      requestAnimationFrame(() => requestAnimationFrame(alignTarget));
      if (document.readyState !== 'complete') window.addEventListener('load', alignTarget, { once: true });
    }

    updateShipping() {
      const configNode = this.querySelector('[data-choice-shipping-config]');
      if (!configNode || !window.PetsUpsellOffers?.shipping) return;
      let config;
      try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
      this.querySelectorAll('[data-choice-shipping]').forEach((label) => {
        // One unit of this card's product, independent of cart and AOV quantities.
        const state = window.PetsUpsellOffers.shipping(config, Number(label.dataset.unitPrice), window.Shopify?.currency);
        label.hidden = !state?.unlocked;
        const benefits = label.closest('.paw-product-choices__benefits');
        const hasSavings = Boolean(benefits?.querySelector('.paw-product-choices__savings'));
        if (benefits) benefits.hidden = label.hidden && !hasSavings;
        label.closest('.paw-product-choices__card')?.classList.toggle('has-benefits', !label.hidden || hasSavings);
      });
    }
  });
}
